<template>
  <div :class="{
    'search-wrapper': true,
    'search-wrapper--opened': showFilters || showSearch,
  }">
    <FilterSwitcher @toggleSearch="toggleSearch" @toggleFilters="toggleFilters" />

    <transition name="slide-left-with-fade">
      <div v-if="showSearch" class="search-listing search-listing-mobile">
        <PopupHeader class="search-listing__header" title="" icon="" @close="toggleSearch" />

        <div class="search-listing__body">
          <InputBox @click="toggle('destination')" class="search-listing__input-box" :label="selectedDestinationLabel" :value="selectedDestinationValue" icon="map" />
          <InputBox @click="toggle('airport')" class="search-listing__input-box" :label="selectedAirportLabel" :value="selectedAirportValue" icon="v" />
          <InputBox @click="toggle('dates')" class="search-listing__input-box" label="Wylot od - Przylot do" :value="selectedDatesValue" icon="calendar" />
          <InputBox @click="toggle('duration')" class="search__input-box" label="Długość pobytu" :value="selectedDurationValue" icon="v" />
          <InputBox @click="toggle('people')" class="search-listing__input-box" label="" :value="selectedPeopleValue" icon="v" />
          <InputBox @click="toggle('pricePerPerson')" class="search-listing__input-box" label="Cena za osobę" :value="selectedPricePerPersonValue" icon="v" />
        </div>

        <transition name="slide-left-with-fade">
          <Destination v-if="popups.destination"
            v-model="destinations"
            @input="toggle('destination')"
            @close="toggle('destination')"
          />
          <Airport v-if="popups.airport"
            v-model="airports"
            @input="toggle('airport')"
            @close="toggle('airport')"
          />
          <MobileCalendar v-if="popups.dates" @close="toggle('dates')"
            :selectedDates="selectedDates"
            :validDates="validDates"
            @selectFrom="selectDateFrom" @selectTo="selectDateTo"
          />
          <Duration v-if="popups.duration"
            v-model="durations"
            @input="toggle('duration')"
            @close="toggle('duration')"
          />
          <People v-if="popups.people"
            v-model="people"
            @input="toggle('people')"
            @close="toggle('people')" />
          <PricePerPerson v-if="popups.pricePerPerson"
            v-model="pricePerPerson.selected"
            :options="pricePerPerson.options"
            @input="toggle('pricePerPerson')"
            @close="toggle('pricePerPerson')" />
        </transition>

        <PopupFooter @select="search" select="Szukaj" selectAll="" clear="" /> 
      </div>
    </transition>

    <transition name="slide-left-with-fade">
      <div v-if="showFilters" class="search-filters search-filters-mobile">
        <PopupHeader class="search-filters__header" title="Filtruj wyniki" icon="filters" @close="toggleFilters" />

        <div class="search-filters__body">
          <InputBox @click="toggle('pricePerPerson')" class="search-listing__input-box" label="Cena za osobę" :value="selectedPricePerPersonValue" icon="v-right" />          
          <InputBox @click="toggle('attractions')" class="search-filters__input-box" :label="selectedAttractionsLabel" :value="selectedAttractionsValue" icon="v-right" />
          <InputBox @click="toggle('offerType')" class="search-filters__input-box" :label="selectedOfferTypeLabel" :value="selectedOfferTypeValue" icon="v-right" />
          <InputBox @click="toggle('hotelStandard')" class="search-filters__input-box" :label="selectedHotelStandardLabel" :value="selectedHotelStandardValue" icon="v-right" />
          <InputBox @click="toggle('boardStandard')" class="search-filters__input-box" :label="selectedBoardStandardLabel" :value="selectedBoardStandardValue" icon="v-right" />
          <InputBox @click="toggle('hotelCategories')" class="search-filters__input-box" :label="selectedHotelCategoriesLabel" :value="selectedHotelCategoriesValue" icon="v-right" />
          <InputBox @click="toggle('forChildren')" class="search-filters__input-box" :label="selectedForChildrenLabel" :value="selectedForChildrenValue" icon="v-right" />
          <InputBox @click="toggle('amenities')" class="search-filters__input-box" :label="selectedAmenitiesLabel" :value="selectedAmenitiesValue" icon="v-right" />
        </div>

        <transition name="slide-left-with-fade">
          <Attractions v-if="popups.attractions"
            v-model="attractions"
            @input="toggle('attractions')"
            @close="toggle('attractions')"
          />
          <OfferType v-if="popups.offerType"
            v-model="offerTypes"
            @input="toggle('offerType')"
            @close="toggle('offerType')"
          />
          <HotelStandard v-if="popups.hotelStandard"
            v-model="hotelStandards"
            @input="toggle('hotelStandard')"
            @close="toggle('hotelStandard')"
          />
          <BoardStandard v-if="popups.boardStandard"
            v-model="boardStandards"
            @input="toggle('boardStandard')"
            @close="toggle('boardStandard')"
          />
          <Beach v-if="popups.beach"
            v-model="beaches"
            @input="toggle('beach')"
            @close="toggle('beach')"
          />
          <SportsEntertainment v-if="popups.sportsEntertainment"
            v-model="sportsEntertainments"
            @input="toggle('sportsEntertainment')"
            @close="toggle('sportsEntertainment')"
          />
          <HotelCategories v-if="popups.hotelCategories"
            v-model="hotelCategories"
            @input="toggle('hotelCategories')"
            @close="toggle('hotelCategories')"
          />
          <ForChildren v-if="popups.forChildren"
            v-model="forChildren"
            @input="toggle('forChildren')"
            @close="toggle('forChildren')"
          />
          <Amenities v-if="popups.amenities"
            v-model="amenities"
            @input="toggle('amenities')"
            @close="toggle('amenities')"
          />
          <PricePerPerson v-if="popups.pricePerPerson"
            v-model="pricePerPerson.selected"
            :options="pricePerPerson.options"
            @input="toggle('pricePerPerson')"
            @close="toggle('pricePerPerson')"
          />
        </transition>

        <PopupFooter @select="search" @clear="clear" select="Filtruj wyniki" selectAll="" />        
      </div>
    </transition>
  </div>
</template>

<script>
import moment from 'moment'
import Vue from 'vue'
import Component from 'vue-class-component'

import Airport from './fields/AirportPopup'
import Amenities from './fields/AmenitiesPopup'
import Attractions from './fields/AttractionsPopup'
import Beach from './fields/BeachPopup'
import Destination from './fields/DestinationPopup'
import ForChildren from './fields/ForChildrenPopup'
import HotelCategories from './fields/HotelCategoryPopup'
import HotelStandard from './fields/HotelStandardPopup'
import OfferType from './fields/OfferTypePopup'
import People from './fields/PeoplePopup'
import PopupFooter from './fields/PopupFooter.vue'
import PopupHeader from './fields/PopupHeader'
import PricePerPerson from './fields/PricePerPersonPopup'
import SportsEntertainment from './fields/SportsEntertainmentPopup'
import FilterSwitcher from './FilterSwitcher.vue'
import InputBox from './InputBox.vue'
import AirportLogic from './logic/Airport'
import AmenitiesLogic from './logic/Amenities'
import AttractionsLogic from './logic/Attractions'
import BeachLogic from './logic/Beach'
import DatesLogic from './logic/Dates'
import DestinationLogic from './logic/Destination'
import ForChildrenLogic from './logic/ForChildren'
import HotelCategoriesLogic from './logic/HotelCategories'
import HotelStandardLogic from './logic/HotelStandard'
import OfferTypeLogic from './logic/OfferType'
import PeopleLogic from './logic/People'
import PricePerPersonLogic from './logic/PricePerPerson'
import SportsEntertainmentLogic from './logic/SportsEntertainment'
import DurationLogic from './logic/Duration'
import Duration from './fields/DurationPopup.vue'
import BoardStandardLogic from './logic/BoardStandard'
import BoardStandard from './fields/BoardStandardPopup.vue'

import Icon from '@/components/Icon.vue'
import MobileCalendar from '@/components/MobileCalendar.vue'
import PopupHandler from '@/components/search/PopupHandler'
import { API, SearchConstraintsRequest } from '@/modules/api'
import ExternalSearchDataAdapter from '@/modules/search/ExternalDataAdapter'
import MediaDetector from '@/utils/MediaDetector'

@Component({
  mixins: [
    PopupHandler,
    DestinationLogic,
    AirportLogic,
    DatesLogic,
    DurationLogic,
    PeopleLogic,
    PricePerPersonLogic,
    OfferTypeLogic,
    AttractionsLogic,
    AmenitiesLogic,
    ForChildrenLogic,
    HotelCategoriesLogic,
    HotelStandardLogic,
    BeachLogic,
    SportsEntertainmentLogic,
    ExternalSearchDataAdapter,
    MediaDetector,
    BoardStandardLogic,
  ],
  components: {
    FilterSwitcher,
    PopupHeader,
    PopupFooter,
    InputBox,
    Icon,
    Destination,
    Airport,
    MobileCalendar,
    Duration,
    People,
    PricePerPerson,
    OfferType,
    BoardStandard,
    Attractions,
    Amenities,
    ForChildren,
    HotelCategories,
    HotelStandard,
    Beach,
    SportsEntertainment,
  },
  props: {
    form: {
      type: HTMLFormElement,
      required: true,
    },
    shouldSetListingFilters: {
      type: Boolean,
      required: false,
    },
  },
})
export default class MobileListing extends Vue {
  showSearch = false
  showFilters = false

  created () {
    new API()
      .getSearchConstraints(new SearchConstraintsRequest())
      .then(this.readSearchConstraintsResponse)
      .then(() => { if (this.shouldSetListingFilters) this.updateNewSearchFilters() })
      .then(this.updateAvailableValues)
  }

  search () {
    this.saveValuesToForm()
    this.form.submitWFFM()
  }

  clear () {
    this.offerTypes.forEach(item => { item.selected = false })
    this.attractions.forEach(item => { item.selected = false })
    this.amenities.forEach(item => { item.selected = false })
    this.forChildren.forEach(item => { item.selected = false })
    this.hotelCategories.forEach(item => { item.selected = false })
    this.hotelStandards.forEach(item => { item.selected = false })
    this.beaches.forEach(item => { item.selected = false })
    this.sportsEntertainments.forEach(item => { item.selected = false })
  }

  saveValuesToForm () {
    this.dx.destination.data = this.destinations
    this.dx.airport.data = this.airports
    this.dx.dates.data = this.selectedDates
    this.dx.duration.data = this.durations
    this.dx.people.data = this.people
    this.dx.pricePerPerson.data = this.pricePerPerson

    this.dx.offerType.data = this.offerTypes
    this.dx.boardStandard.data = this.boardStandards
    this.dx.attractions.data = this.attractions
    this.dx.amenities.data = this.amenities
    this.dx.forChildren.data = this.forChildren
    this.dx.hotelCategories.data = this.hotelCategories
    this.dx.hotelStandard.data = this.hotelStandards
    this.dx.beach.data = this.beaches
    this.dx.sportsEntertainment.data = this.sportsEntertainments
  }

  updateAvailableValues () {
    this.saveValuesToForm()
    new API()
      .getSearchConstraints(SearchConstraintsRequest.fromWFFMForm(this.form))
      .then(this.updateSearchConstraintsResponse)
  }

  /**
   * @argument {SearchConstraintsResponse} response
   */
  readSearchConstraintsResponse (response) {
    this.setDatesSelectedOnStart(response.minDate, response.maxDate)
    this.validDates = moment.range(response.minDate, response.maxDate)
    this.markAvailabilityOfRadioElements(this.durations.ranges, response.validRanges)
    this.markAvailabilityOfListEntries(this.airports, response.airports)
    this.markAvailabilityOfListEntries(this.destinations, response.destinations)
    this.airports = this.airports.sort((a1, a2) => a1.name.localeCompare(a2.name))
    this.destinations = this.destinations.sort((d1, d2) => d1.name.localeCompare(d2.name))
    this.offerTypes = this.offerTypes.sort((ot1, ot2) => ot1.name.localeCompare(ot2.name))
    this.boardStandards = this.boardStandards.sort((fc1, fc2) => fc1.name.localeCompare(fc2.name))
    this.attractions = this.attractions.sort((a1, a2) => a1.name.localeCompare(a2.name))
    this.amenities = this.amenities.sort((a1, a2) => a1.name.localeCompare(a2.name))
    this.forChildren = this.forChildren.sort((fc1, fc2) => fc1.name.localeCompare(fc2.name))
    this.hotelCategories = this.hotelCategories.sort((fc1, fc2) => fc1.name.localeCompare(fc2.name))
    this.beaches = this.beaches.sort((b1, b2) => b1.name.localeCompare(b2.name))
    this.sportsEntertainments = this.sportsEntertainments.sort((se1, se2) => se1.name.localeCompare(se2.name))
  }

  /**
   * @argument {SearchConstraintsResponse} response
   */
  updateSearchConstraintsResponse (response) {
    this.selectedDates = moment.range(moment.max(this.selectedDates.start, response.minDate), moment.min(this.selectedDates.end, response.maxDate))
    this.validDates = moment.range(response.minDate, response.maxDate)
    this.markAvailabilityOfRadioElements(this.durations.ranges, response.validRanges)
    this.markAvailabilityOfListEntries(this.airports, response.airports)
    this.markAvailabilityOfListEntries(this.destinations, response.destinations)
    this.airports = this.airports.sort((a1, a2) => a1.name.localeCompare(a2.name))
    this.destinations = this.destinations.sort((d1, d2) => d1.name.localeCompare(d2.name))
    this.offerTypes = this.offerTypes.sort((ot1, ot2) => ot1.name.localeCompare(ot2.name))
    this.boardStandards = this.boardStandards.sort((fc1, fc2) => fc1.name.localeCompare(fc2.name))
    this.attractions = this.attractions.sort((a1, a2) => a1.name.localeCompare(a2.name))
    this.amenities = this.amenities.sort((a1, a2) => a1.name.localeCompare(a2.name))
    this.forChildren = this.forChildren.sort((fc1, fc2) => fc1.name.localeCompare(fc2.name))
    this.hotelCategories = this.hotelCategories.sort((fc1, fc2) => fc1.name.localeCompare(fc2.name))
    this.beaches = this.beaches.sort((b1, b2) => b1.name.localeCompare(b2.name))
    this.sportsEntertainments = this.sportsEntertainments.sort((se1, se2) => se1.name.localeCompare(se2.name))

    this.attractions = this.attractions.filter(item => item.name.toLowerCase() !== 'dodaj auto do kompletu')
  }

  markAvailabilityOfListEntries (list, ids) {
    list.forEach(item => {
      item.enabled = ids.some(x => item.value.indexOf(x) !== -1)
      if (!item.enabled) item.selected = false
    })
  }

  markAvailabilityOfRadioElements (list, ids) {
    list.forEach(item => {
      item.enabled = ids.some(x => x === item.value)
    })
  }

  setDatesSelectedOnStart (min, max) {
    const before = moment(this.selectedDates.start).isBefore(min)
    if (before) this.selectedDates = moment.range(min, max)
  }

  toggleSearch () {
    this.showSearch = !this.showSearch
    if (this.showSearch) this.freezeBody()
    else this.unfreezBody()
  }

  toggleFilters () {
    this.showFilters = !this.showFilters
    if (this.showFilters) this.freezeBody() 
    else this.unfreezBody()
  }

  get page () {
    return document.querySelector('.master-page-container')
  }
}
</script>

<style lang="scss" scoped>
@import './mobile-popup';

.search-wrapper {
  position: fixed;
  width: 100vw;
  top: 55px;
  z-index: 1032;

  &--opened {
    // need to be placed on top of opened mobile menu
    z-index: 1036;
  }
}

.search-listing {
  @include mobile-popup(white, #005ca9);

  display: flex;
  flex-direction: column;
  align-content: start;

  &__body {
    // in this case we don't include the body (yet) because the "search" button is
    // glued to the rest of the controls and not separated at the bottom of the screen
    padding: 0 20px;
  }

  &__input-box {
    margin-bottom: 10px;
  }

  &__advertisment {
    padding: 0 20px;
    text-align: center;
    font-family: Georgia;
    font-size: 13px;
    font-style: italic;
    color: rgba(255, 255, 255, 0.5);
    margin: 0 15px 15px 15px;
  }
}

.search-filters {
  @include mobile-popup(white, #009FEA);

  display: flex;
  flex-direction: column;

  &__body {
    @include mobile-popup__body(#009FEA, white);

    grid-auto-rows: 48px;
  }

  &__input-box {
    margin-bottom: 7px;

    @include media(tablet) {
      margin-bottom: 9px;
    }
  }
}
</style>

<style lang="scss">
.search-listing-mobile {
  > .control-footer {
    padding: 0 20px;
    position: relative;
    background-color: transparent;

    button {
      border: 2px solid #fff;
      background-color: transparent;
    }
  }
}
.search-filters-mobile {
  .input-box__value {
    color: #005ca9;
    font-weight: 500;
    border-bottom: solid 1px #009FEA;
    text-transform: uppercase;
    padding-bottom: 6px;

    .figure--v-right {
      height: 27px;
      padding-top: 8px;
      padding-right: 5px;
    }
  }

  .checklist-item__label {
    text-transform: uppercase;
  }

  .checkbox-label--selected {
    color: #005ca9;
    font-weight: 500;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/search/MobileListing.vue